export const dataTemplatesTableConfig = {
     list: {
          tableMapper: [
               {
                    id: "name",
                    name: "Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "dataTemplateType",
                    name: "Type",
                    isShow: true,
                    align: "center",
                    type: "text",
               },
               {
                    id: "labels",
                    name: "Labels",
                    isShow: true,
                    align: "center",
                    type: "label",
               },
               {
                    id: "totalRecords",
                    name: "Total Records",
                    isShow: true,
                    align: "center",
                    type: "text",
                    isNormalTest: true,
               },
               {
                    id: "inUse",
                    name: "In Use",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "active",
                    name: "Active",
                    isShow: true,
                    align: "right",
                    type: "activeButton",
               },
               {
                    id: "",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               // {
               //      id: "",
               //      name: "",
               //      isShow: true,
               //      align: "left",
               //      type: "",
               // },
          ],
     },

     schemaList: {
          tableMapper: [
               {
                    id: "name",
                    name: "Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "type",
                    name: "Type",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "identity",
                    name: "Identity",
                    isShow: true,
                    align: "center",
                    type: "text",
               },
               {
                    id: "required",
                    name: "Required",
                    isShow: true,
                    align: "center",
                    type: "text",
               },
               {
                    id: "filterable",
                    name: "Filterable",
                    isShow: true,
                    align: "center",
                    type: "text",
               },

               {
                    id: "attribute",
                    name: "Attribute",
                    isShow: true,
                    align: "left",
                    type: "object",
               },
                
          ],
     },
     ParticipantUserAccount: {
          tableMapper: [
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "firstName",
                    name: "First Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "lastName",
                    name: "Last Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "dealerCode",
                    name: "Dealer",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "jobRole",
                    name: "Job Role",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
          ],
          userTableMapper:[
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
                              {
                    id: "email",
                    name: "Email",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
          ]
     }

};
